import { render, staticRenderFns } from "./Trebovanje.vue?vue&type=template&id=a188e77a&"
import script from "./Trebovanje.vue?vue&type=script&lang=ts&"
export * from "./Trebovanje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports